import React from 'react';
import TeachersList from '../components/Teachers';
import { FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import SEO from '../components/SEO';

const Teachers = () => {
  return (
    <div className="animate-fadeIn">
      <SEO page="teachers" />
      {/* Hero Section with Background */}
      <section className="relative bg-gradient-to-br from-cyan-900 via-sky-800 to-blue-900 pt-32 pb-40 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-4 border-white rounded-full"></div>
          <div className="absolute top-20 right-20 w-20 h-20 border-4 border-white"></div>
          <div className="absolute bottom-10 left-1/4 w-24 h-24 border-4 border-white rounded-full"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Breadcrumbs */}
          <div className="flex items-center justify-center space-x-2 text-sm text-cyan-200 mb-6" data-aos="fade-down">
            <a href="/" className="hover:text-white transition-colors">Home</a>
            <span className="text-cyan-400">/</span>
            <span className="text-white font-medium">Teachers</span>
          </div>

          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-aos="fade-up">
              <SafeIcon icon={FiUsers} className="w-5 h-5 text-white" />
              <span className="text-white font-medium">Our Team</span>
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6" data-aos="fade-up" data-aos-delay="100">
              Meet Our Educators
            </h1>
            
            <p className="text-xl text-cyan-100 leading-relaxed" data-aos="fade-up" data-aos-delay="200">
              Our passionate and qualified teachers are dedicated to nurturing your child's potential 
              through love, patience, and expertise.
            </p>
          </div>
        </div>

        {/* Decorative Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
            <path fill="#ffffff" fillOpacity="1" d="M0,64L48,69.3C96,75,192,85,288,80C384,75,480,53,576,48C672,43,768,53,864,58.7C960,64,1056,64,1152,58.7C1248,53,1344,43,1392,37.3L1440,32L1440,120L1392,120C1344,120,1248,120,1152,120C1056,120,960,120,864,120C768,120,672,120,576,120C480,120,384,120,288,120C192,120,96,120,48,120L0,120Z"></path>
          </svg>
        </div>
      </section>

      <TeachersList />
    </div>
  );
};

export default Teachers;